import React from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './lesson-index-header.style';
import { isBigScreen } from '../../../components/media-query';
import { NavbarIconButton } from '../../../components/navbar-icon-button/navbar-icon-button';
import { useColors, useLessonContext } from '../../../hooks';
import ThemedText2 from '../../themed-text-2';

interface LessonIndexHeaderProps {
  title?: string;
  subtitle?: string;
}

const LessonIndexHeader: React.FC<LessonIndexHeaderProps> = ({
  title,
  subtitle,
}) => {
  const colors = useColors();
  const { hideIndex } = useLessonContext();
  const isMobile = !isBigScreen();

  if (!title && !subtitle) {
    return null;
  }

  return (
    <SafeAreaView
      style={[styles.container, { borderColor: colors.grayLight }]}
      edges={['top']}
    >
      {isMobile && (
        <NavbarIconButton
          onPress={hideIndex}
          size={18}
          iconButtonStyle={styles.leftButton}
          icon="arrow-left"
        />
      )}
      <View style={styles.textContainer}>
        {!!title && <ThemedText2 fontWeightStyle="bold">{title}</ThemedText2>}
        {!!subtitle && (
          <ThemedText2 style={styles.subtitle} fontSize={12}>
            {subtitle}
          </ThemedText2>
        )}
      </View>
      {!isMobile && (
        <NavbarIconButton
          icon="times"
          onPress={hideIndex}
          iconButtonStyle={styles.rightButton}
          size={18}
        />
      )}
    </SafeAreaView>
  );
};

export default LessonIndexHeader;
